module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai767-8d247c2e385c8d65a0ec7441bba6d19f.jpg";